import React from 'react';
import S from './StyledCommonSeoPage';

const CommonSeoPage = ({ children }) => {
    return ( 
        <S.CommonSeoPageWrapper>
            {children}
        </S.CommonSeoPageWrapper>
     );
}
 
export default CommonSeoPage;
